import classNames from 'classnames';
import { memo, useEffect, useRef, useState } from 'react';
import { calculateHorizontalShift } from './helpers';
import styles from './styles.module.scss';

export interface ITooltipProps {
  text: string;
  visible: boolean;
  offset?: number;
  position: 'left' | 'top' | 'bottom' | 'right';
}

const Tooltip = ({ visible, text, position, offset = 0 }: ITooltipProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [horizontalShift, setHorizontalShift] = useState(0);

  const marginLeft = position === 'top' || position === 'bottom' ? offset : 0;
  const marginTop = position === 'left' || position === 'right' ? offset : 0;

  useEffect(() => {
    if (!ref.current) return;

    // needs to reset margin before recalculating
    ref.current.style.marginLeft = `${marginLeft}px`;

    setHorizontalShift(calculateHorizontalShift(ref.current));
  }, [ref, text, visible, marginLeft, position]);

  return (
    <div
      ref={ref}
      role='tooltip'
      style={{ marginLeft: marginLeft + horizontalShift, marginTop }}
      className={classNames(styles.tooltip, styles[position], { [styles.visible]: visible })}
    >
      {text}
      <div className={styles.tooltipArrow} style={{ marginLeft: -horizontalShift }} />
    </div>
  );
};

export default memo(Tooltip);
